module.exports = __webpack_public_path__ + "img/banner.36a876e1.jpg";